// extracted by css-extract-rspack-plugin
export default {"responsiveFrame":"recommendation-fragment__ResponsiveFrame_responsiveFrame__slyqP"};